const API_URL = process.env.REACT_APP_STRAPI_URL || "https://strapi.wnt.rs";
const DEFAULT_OPTIONS = {
  headers: {
    Authorization:
      process.env.REACT_APP_STRAPI_TOKEN ||
      "bearer 3851fae91a8ed876320b4e590d0a0f66660dd1bf150ca863a35bd57d14fd36c2ab5577b43139912558d3a1df9b87cd6df40036f465627c51e8db741ab4171cbf749585727649bd0ad4c2e38fefc66503e3821a6ba1cba104cd239d65e708e8b625bc71fb5668811c8a60738fa5a78cbf45ba5bb1d0028f098cb57f04aa1b4e99",
  },
};

export async function fetchCollectives(locale) {
  const response = await fetch(
    `${API_URL}/api/collectives?populate=*&locale=${locale}`,
    DEFAULT_OPTIONS,
  );

  const data = await response.json();

  return data.data;
}

export async function fetchCollective(locale, id) {
  const response = await fetch(
    `${API_URL}/api/collectives/${id}?populate=*&locale=${locale}`,
    DEFAULT_OPTIONS,
  );

  const data = await response.json();

  return data.data;
}

export async function fetchWeeklySchedule(locale) {
  const response = await fetch(
    `${API_URL}/api/weekly-schedule?populate[0]=Monday.Events&populate[1]=Tuesday.Events&populate[2]=Wednesday.Events&populate[3]=Thursday.Events&populate[4]=Friday.Events&populate[5]=Saturday.Events&populate[6]=Sunday.Events&locale=${locale}`,
    DEFAULT_OPTIONS,
  );

  const data = await response.json();

  return data.data;
}

export async function fetchAcquisitionFaq(locale) {
  const response = await fetch(
    `${API_URL}/api/acquisition-page?populate=*&locale=${locale}`,
    DEFAULT_OPTIONS,
  );

  const data = await response.json();

  return data.data;
}

export function getImageUrl(url) {
  return API_URL + url;
}

export async function fetchFundraiseProgress() {
  const response = await fetch(
    `${API_URL}/api/acquisition-progress-bar?populate=*`,
    DEFAULT_OPTIONS,
  );

  const data = await response.json();

  return data.data;
}
